export const setRumGlobalContext = (uuid: string) => {
  window.DD_RUM?.addRumGlobalContext('uuid', uuid);
};

type AddAction = (action: string, properties?: Record<string, unknown>) => void;
export const addAction: AddAction = (action, properties = {}) => {
  window.DD_RUM?.addAction(action, {
    ...properties,
    pathname: window.location.pathname,
  });
};
